import * as React from 'react';
import { Tag } from 'src/design-system/components/atoms';
import { useTheme } from 'src/theming/useTheme';

export const DefaultTag = () => {
  const theme = useTheme();
  return (
    <Tag color="blue" style={{ marginTop: theme.spacing[1] }}>
      Default
    </Tag>
  );
};

export const EmptyTag = () => {
  const theme = useTheme();
  return (
    <Tag color="volcano" style={{ marginTop: theme.spacing[1] }}>
      Empty
    </Tag>
  );
};

export const SimpleTag = ({ label }) => {
  const theme = useTheme();
  return <Tag style={{ marginTop: theme.spacing[1] }}>{label}</Tag>;
};

export const OrgAliases = ({ tags }) => {
  return tags.map((tag, index) => {
    switch (tag) {
      case '':
        return <EmptyTag key={index} />;
      case null:
        return <DefaultTag key={index} />;
      default:
        return <SimpleTag label={tag} key={index} />;
    }
  });
};

export const PrettyOption = ({ label, description, labelFontSize, descriptionFontSize }) => {
  const theme = useTheme();
  return (
    <>
      <div style={{
        fontSize: labelFontSize || theme.typography.fontSize.sm,
      }}>{label}</div>
      <div
        style={{
          fontStyle: 'italic',
          fontSize: descriptionFontSize || theme.typography.fontSize.sm,
          color: theme.color.semantic.text.soft,
          whiteSpace: 'initial',
        }}
      >
        {description}
      </div>
    </>
  );
};
